import { pub } from "./pub";
import { auth } from "./auth";
import { email } from "./email";
import { file } from "./file";
import { mailmerge } from "./mailmerge";
import { record } from "./record";
import { user } from "./user";
import { config } from "./config";
import { inventory } from "./inventory";
import { coql } from "./coql";

export const zohoApi = {
  pub,
  auth,
  email,
  file,
  mailmerge,
  record,
  user,
  config,
  inventory,
  coql,
};
